/**
 * @author lihh
 * @description 表示全职 实习
 */
// 导入axios
import request from '@/utils/request';

import {
  SERVICE_TYPE_HPM
} from '@/utils/define';

/**
 * @author lihh
 * @description 表示推荐职位
 * @param {*} data 
 * @param current 表示页数
 * @param size 表示每页条数
 */
export function JobListAuto(current = 1, size = 4, data = {}, type = '1') {

    // 表示需要toekn
    data['tokenNeed'] = 1;

    return request({
        url: `/${SERVICE_TYPE_HPM}/Job/JobListAuto?current=${current}&size=${size}&type=${type}`,
        method: 'POST',
        data
      });
}

/**
 * @author lihh
 * @description 表示职位列表
 * @param {*} data 
 * @param current 表示页数
 * @param size 表示每页条数
 */
export function JobList(current = 1, size = 4, data = {}, type = '1') {

    // 表示需要toekn
    data['tokenNeed'] = 1;

    return request({
        url: `/${SERVICE_TYPE_HPM}/Job/JobList?current=${current}&size=${size}&type=${type}`,
        method: 'POST',
        data
      });
}

/**
 * @author lihh
 * @description 表示进行职位收藏
 * @param {*} data
 * @param id 表示企业 或是 职位 或是 双选会 id
 * @param type 1:职位收藏 2: 企业收藏 3:双选会收藏 
 */
export function Collect(id, type, data = {}) {

  // 表示需要toekn
  data['tokenNeed'] = 1;

  return request({
      url: `/${SERVICE_TYPE_HPM}/Operate/Collect?id=${id}&type=${type}`,
      method: 'POST',
      data
    });
}

/**
 * @author lihh
 * @description 查询职位相关的地址
 * @param {*} data
 * @param positionId 表示职位id
 */
export function GetCitysByJob(positionId, data = {}) {

  // 表示需要toekn
  data['tokenNeed'] = 1;

  return request({
      url: `/${SERVICE_TYPE_HPM}/Job/GetCitysByJob?positionId=${positionId}`,
      method: 'POST',
      data
    });
}

/**
 * @author lihh
 * @description 进行简历投递
 * @param {*} data
 */
export function JobApply(data = {}) {

  // 表示需要toekn
  data['tokenNeed'] = 1;

  return request({
      url: `/${SERVICE_TYPE_HPM}/Operate/JobApply`,
      method: 'POST',
      data
    });
}


/**
 * @author lihh
 * @description 进行简历投递 ---简历待收集
 * @param {*} data
 */
 export function JobApplyD(data = {}) {

  // 表示需要toekn
  data['tokenNeed'] = 1;

  return request({
      url: `/${SERVICE_TYPE_HPM}/Operate/JobApplyD`,
      method: 'POST',
      data
    });
}


// WEBPACK FOOTER //
// ./src/api/request/jobService.js